const wrapper = "_0mwrco57f";
const heading = "_0mh1imqavn";
const cardsList = "_0mcmlohk8";
const card = "_0mc5qno22";

export { card, cardsList, heading, wrapper };
import "./organism.cta.style.linaria.module.css";
//# sourceMappingURL=organism.cta.style.js.map
